import React from "react";

export const STATUS_STYLES = {
  success: { bg: "#ecfdf5", border: "#6ee7b7", color: "#065f46", label: "Success" },
  failed: { bg: "#fef2f2", border: "#fca5a5", color: "#991b1b", label: "Failed" },
  in_progress: { bg: "#eff6ff", border: "#93c5fd", color: "#1e40af", label: "In Progress" },
  cancelled: { bg: "#f3f4f6", border: "#d1d5db", color: "#4b5563", label: "Cancelled" },
  other: { bg: "#f3f4f6", border: "#d1d5db", color: "#4b5563", label: null },
};

export const ACTION_STYLES = {
  provisioning: { bg: "#eef2ff", color: "#3730a3" },
  migration: { bg: "#fdf4ff", color: "#86198f" },
  password_reset: { bg: "#fffbeb", color: "#92400e" },
  other: { bg: "#f3f4f6", color: "#374151" },
};

export function StatusBadge({ group, status }) {
  const s = STATUS_STYLES[group] || STATUS_STYLES.other;
  return (
    <span
      title={status}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        padding: "2px 10px",
        borderRadius: 999,
        border: `1px solid ${s.border}`,
        background: s.bg,
        color: s.color,
        fontSize: 12,
        fontWeight: 600,
        whiteSpace: "nowrap",
      }}
    >
      {group === "in_progress" && <span className="automation-pulse" />}
      {s.label || status}
    </span>
  );
}

export function ActionLabel({ action, label }) {
  const s = ACTION_STYLES[action] || ACTION_STYLES.other;
  return (
    <span
      style={{
        display: "inline-block",
        padding: "2px 8px",
        borderRadius: 6,
        background: s.bg,
        color: s.color,
        fontSize: 12,
        fontWeight: 600,
        whiteSpace: "nowrap",
      }}
    >
      {label}
    </span>
  );
}

export function formatDateTime(value) {
  if (!value) return "—";
  return new Date(value).toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}

export function formatMb(mb) {
  if (mb == null) return "—";
  if (mb >= 1024 * 1024) return `${(mb / (1024 * 1024)).toFixed(2)} TB`;
  if (mb >= 1024) return `${(mb / 1024).toFixed(2)} GB`;
  return `${Number(mb).toLocaleString(undefined, { maximumFractionDigits: 1 })} MB`;
}

export function formatMigrationData(data) {
  if (!data) return null;
  const parts = [formatMb(data.total_data_mb)];
  if (data.file_count != null) parts.push(`${data.file_count.toLocaleString()} files`);
  return parts.join(" · ");
}

// The automations run in us-east-1, so the portal builds AWS console links itself.
const AUTOMATION_REGION = "us-east-1";

export function awsConsoleUrl(executionId, step) {
  const base = `https://${AUTOMATION_REGION}.console.aws.amazon.com/systems-manager/automation/execution/${executionId}`;
  const path = step ? `/step/${step.step_number}/${step.step_execution_id}` : "";
  return `${base}${path}?region=${AUTOMATION_REGION}`;
}

export function formatDuration(seconds) {
  if (seconds == null) return "—";
  if (seconds < 60) return `${seconds}s`;
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  if (m < 60) return `${m}m ${s}s`;
  return `${Math.floor(m / 60)}h ${m % 60}m`;
}

export const automationStyles = `
  .automation-pulse {
    width: 7px; height: 7px; border-radius: 50%; background: #3b82f6;
    animation: automation-pulse 1.2s ease-in-out infinite;
  }
  @keyframes automation-pulse { 0%,100% { opacity: 1; } 50% { opacity: 0.3; } }
  .automation-btn {
    height: 30px; padding: 0 12px; border: 1px solid #d1d5db; border-radius: 6px;
    background: #ffffff; color: #374151; font-size: 13px; font-weight: 500; cursor: pointer;
    text-decoration: none; display: inline-flex; align-items: center;
  }
  .automation-btn:hover { background: #f3f4f6; }
  .automation-btn:disabled { cursor: not-allowed; opacity: 0.6; }
  .automation-table { width: 100%; border-collapse: collapse; font-size: 13px; }
  .automation-table th {
    text-align: left; font-size: 11px; font-weight: 700; color: #6b7280; letter-spacing: 0.06em;
    text-transform: uppercase; padding: 12px; border-bottom: 1px solid #e5e7eb; background: #f9fafb;
    position: sticky; top: 0;
  }
  .automation-table td { padding: 10px 12px; border-bottom: 1px solid #f3f4f6; color: #374151; vertical-align: top; }
  .automation-table tr:hover td { background: #f9fafb; }
  .automation-muted { color: #9ca3af; font-size: 12px; }
  .automation-error {
    color: #991b1b; font-size: 12px; margin-top: 4px; max-width: 420px;
    overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
  }
`;
